var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{attrs:{"fluid":"","fill-height":""}},[_vm._t("default")],2),_c('voeter',{attrs:{"showLegal":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }